import React, { useMemo } from 'react';
export function Background() {
  // Compute star positions once, not on every render.
  const stars = useMemo(() => Array.from({
    length: 28
  }, () => ({
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
    size: `${Math.random() * 2 + 1}px`,
    opacity: Math.random() * 0.5 + 0.15
  })), []);
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" data-id="element-263">
      {/* Subtle gradient overlay (cheap, no filter blur) */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-mystic-800/50 via-mystic-900/80 to-mystic-900" data-id="element-264"></div>

      {/* Stars */}
      <div className="absolute inset-0 opacity-30" data-id="element-265">
        {stars.map((s, i) => <div key={i} className="absolute rounded-full bg-white" style={{
        top: s.top,
        left: s.left,
        width: s.size,
        height: s.size,
        opacity: s.opacity
      }} data-id="element-266" />)}
      </div>

      {/* Sacred Geometry SVG (subtle, static) */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] max-w-none opacity-[0.03] text-gold" data-id="element-267">
        <svg viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.2" data-id="element-268">
          <circle cx="50" cy="50" r="40" data-id="element-269" />
          <circle cx="50" cy="50" r="30" data-id="element-270" />
          <circle cx="50" cy="50" r="20" data-id="element-271" />
          <polygon points="50,10 84.6,30 84.6,70 50,90 15.4,70 15.4,30" data-id="element-272" />
          <polygon points="50,10 84.6,70 15.4,70" data-id="element-273" />
          <polygon points="50,90 84.6,30 15.4,30" data-id="element-274" />
        </svg>
      </div>
    </div>;
}